import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerInfoResponse } from '@tool/models/server-info.model';
import { ServerInfoService } from '@tool/services/server-info.service';

@Component({
    selector: 'bv-tool-footer',
    templateUrl: './tool-footer.component.html',
    styleUrls: ['./tool-footer.component.scss'],
    standalone: false
})
export class ToolFooterComponent implements OnInit {
  public info!: Observable<ServerInfoResponse>;
  private serverInfoService: ServerInfoService = inject(ServerInfoService);

  public ngOnInit(): void {
    this.info = this.serverInfoService.getServerInfo();
  }
}
